export const getPricePath = (customerNumber: string, variantSelected?: boolean) =>
    `prices/getlistprices/${customerNumber}?version=10${
        variantSelected ? "&variantSelected=true" : ""
    }`;
